export const DEFAULT_VALUE = {
    enabled: false,
    queryString: "",
    optimizeID: "",
    allTraffic: false,
};
